/* eslint-disable no-unused-vars */
export enum TargetTab {
  REGISTRATION_INFO = 1,
  ADMINISTRATIVE_MANAGEMENT_INFO = 2,
  LABORREGULATIONS = 3,
  FINANCIAL_REPORTS = 12,
  COMPANY_POLICIES = 5,
  EMPLOYEMNT_CONTRACT = 7,
  LABOR_DOCUMENT = 11,
  AGREEMENTS = 13,
  ROLE_PERMISSIONS = 10,
  BUSSINESS_FLOWCHARTS = 14,
  BUSSINESS_MANUALS = 15,
}

export enum TargetTabString {
  REGISTRATION_INFO = "registration_info",
  ADMINISTRATIVE_MANAGEMENT_INFO = "administrative_management_info",
  LABORREGULATIONS = "laborregulations",
  FINANCIAL_REPORTS = "financial_reports",
  COMPANY_POLICIES = "company_policies",
  ROLE_PERMISSIONS = "role_permissions",
  LABOR_DOCUMENTS = "labor_documents",
  EMPLOYEMNT_CONTRACT = "employment_contracts",
  BUSINESS_MANUALS = "business_manuals",
  AGREEMENTS = "agreements",
  BUSSINESS_FLOWCHARTS = "business_flowcharts",
  BUSSINESS_MANUALS = "business_manuals",
}
